export const NAME_EX_TYPE = "warning";
export const NAME_EX_TITL = "User already present";
export const NAME_EX__SUBT = "There is already a user with the name ";
export const EMPTY_STR_TYPE = "warning";
export const EMPTY_STR_TITL = "No name entered";
export const EMPTY_STR_SUBT = "Please provide a name for the new mitglieder";
export const ADDUSR_ERR_TYPE = "warning";
export const ADDUSR_ERR_TITL = "User not added";
export const ADDUSR_ERR_SUBT =
	"An error occurred during the operation. Please try again";
